export default __webpack_public_path__ + "static/media/coverEN.cf160c1c.jpg";